import { Button, JoonUIColor, Modal, Typography } from "@joonapp/web-shared"
import { useQueryClient } from "@tanstack/react-query"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { QUERY_KEYS } from "../../constants"
import { useUserQuery } from "../../networking/queries"
import { useAuth } from "../../util/auth"
import { createJoonAPIClient } from "../../util/joon-api"

const DeleteAccount = () => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { signout } = useAuth()
  const { user } = useUserQuery()
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const deleteAccount = async () => {
    setIsLoading(true)
    const API = createJoonAPIClient()
    await API.delete(`/api/users/${user?.id}/?app_type=parent`)
    setIsLoading(false)
    signout()
    setOpenConfirmModal(false)
    queryClient.invalidateQueries([QUERY_KEYS.USER])
  }

  return (
    <>
      <Modal
        isOpen={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        animate
        style={{ width: "min(350px, 95vw)" }}
      >
        <div className="w-full flex flex-col gap-4 p-6 pt-4">
          <Typography variant="h2">{t("DEL_CONFIRM_TITLE")}</Typography>
          <Typography variant="body">{t("DEL_CONFIRM_DESC")}</Typography>
          <div className="flex gap-2 mt-2">
            <Button
              text={t("QB_CANCEL")}
              onClick={() => setOpenConfirmModal(false)}
              fullWidth
            />
            <Button
              buttonType="redPrimary"
              onClick={deleteAccount}
              isLoading={isLoading}
              text={t("QB_DELETE")}
              fullWidth
            />
          </div>
        </div>
      </Modal>
      <button
        onClick={() => setOpenConfirmModal(true)}
        className="mt-[10vh] w-fit"
      >
        <Typography
          variant="bodySmallBold"
          color={JoonUIColor.semantic.destructive}
        >
          {t("DEL_DELETE_ACCOUNT")}
        </Typography>
      </button>
    </>
  )
}

export default DeleteAccount
